import { render } from "./assignees.vue?vue&type=template&id=0a3a891a"
import script from "./assignees.vue?vue&type=script&lang=js"
export * from "./assignees.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__